import Swiper from "swiper";
import { Pagination, Navigation, EffectCreative, Controller } from "swiper/modules";

const initGallerySlider = () => {
  const swipers = document.querySelectorAll(".js-gallery-slider");

  if (swipers.length === 0) return;

  swipers.forEach((swiper) => {
    const counterCurrent = swiper.parentNode.querySelector(".image-slider__current");
    const counterTotal = swiper.parentNode.querySelector(".image-slider__total");
    const carouselEl = swiper.querySelector(".swiper");
    const progressbarEl = swiper.parentNode.querySelector(".swiper-pagination");
    const counterWrapperEl = swiper.parentNode.querySelector(".swiper-counter");

    const carouselImage = new Swiper(carouselEl, {
      breakpoints: {
        0: {
          slidesPerView: 1.15,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1.3,
          spaceBetween: 21,
        },
      },
      speed: 600,
      pagination: {
        el: ".swiper-pagination.swiper-pagination-gallery-slider",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next.swiper-buttons-gallery-slider",
        prevEl: ".swiper-button-prev.swiper-buttons-gallery-slider",
      },
      on: {
        afterInit() {
          counterTotal.innerText = `${this.slides.length}`;
        },
        slideChange: () => {
          counterCurrent.innerText = `${carouselImage.realIndex + 1}`;
        },
      },
      modules: [Pagination, Navigation, EffectCreative, Controller],
      watchSlidesProgress: true,
    });

    const slideWidth = carouselImage.slides[0].offsetWidth;
    const nextSlideBtn = swiper.querySelector(".swiper-button-next.swiper-buttons-gallery-slider");
    // Position the button to be on the right side of the image
    nextSlideBtn.style.left = `calc(${slideWidth}px - ${nextSlideBtn.offsetWidth}px / 2)`;

    const counterWidth = counterWrapperEl.offsetWidth;
    progressbarEl.style.width = `${slideWidth - counterWidth - 20}px`;
  });
};

export default initGallerySlider;
